import React, { memo, FunctionComponent } from 'react';
import { Button as StyledButton } from 'elements/Button/style';
import { IButton } from 'elements/Button/types';

const Button: FunctionComponent<IButton> = ({
  className = '',
  children,
  onClick = (event: React.MouseEvent<HTMLButtonElement>) => {},
  disabled = false,
  variant = 'contained',
  type,
  fullWidth,
  startIcon,
  endIcon,
  color = 'primary',
  isFilterDropdown,
  ariaLive
}) => {
  className = `btn ${className}`;
  return (
    <StyledButton
      fullWidth={fullWidth}
      disabled={disabled}
      variant={variant}
      className={className}
      onClick={onClick}
      startIcon={startIcon}
      endIcon={endIcon}
      color={color}
      type={type || 'button'}
      isFilterDropdown={isFilterDropdown}
      aria-live={ariaLive}
    >
      {children}
    </StyledButton>
  );
};



export default memo(Button);
